




































































import { computed, defineComponent, onBeforeMount, toRefs, watch } from '@vue/composition-api'
import { Home, Search, FormatDate } from '@/views/Home.vue'
import { HttpPOST, SetPrice, GetPDFTemplate, RedirecPagMantenimiento } from '@/code/Utils'
import Alerts, { AlertType } from '@/code/alerts'

import Pagination from '@/components/pagination.vue'

var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default defineComponent({
    name: "tablaVisualizar",
    components: {
        Pagination
    },
    setup(props, context) {
        const tablaVisualizar = computed(() => {
            return (Home.tablas.visualizar.filter(item => { return item.show })).slice(Home.pagination.page * Home.pagination.rowPerPage, Home.pagination.page * Home.pagination.rowPerPage + Home.pagination.rowPerPage);
        })

        watch(() => Home.desde, (value, oldvalue) => {
            const alert = document.querySelector(".pol-alert");
            if (alert)
                alert.classList.remove('show');
            if (value != oldvalue) {
                VisualizarDDJJ()
            }
        })

        watch(() => Home.hasta, (value, oldvalue) => {
            const alert = document.querySelector(".pol-alert");
            if (alert)
                alert.classList.remove('show');
            if (value != oldvalue) {
                VisualizarDDJJ()
            }
        })

        const VisualizarDDJJ = async () => {
            const alert = document.querySelector(".pol-alert");
            if (alert)
                alert.classList.remove('show');
            const from = Date.parse(Home.desde);
            const to = Date.parse(Home.hasta);
            const min = Date.parse(Home.min)
            const max = Date.parse(Home.max);

            if(from >= min && to <= max){
                let ddjj_id;
                context.root.$store.commit('ChangeLoader', true)
                Home.tablas.visualizar = [];

                const response = await HttpPOST(`<?xml version="1.0" encoding="utf-8"?>
                                                <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                                                    <soap12:Body>
                                                        <getCabPosByCompanyCodeVF xmlns="http://tempuri.org/">
                                                            <companyCode>${context.root.$store.state.session.companyCode}</companyCode>
                                                            <fechaini>${FormatDate(Home.desde)}</fechaini>
                                                            <fechafin>${FormatDate(Home.hasta)}</fechafin>
                                                            <estado>A</estado>
                                                        </getCabPosByCompanyCodeVF>
                                                    </soap12:Body>
                                                </soap12:Envelope>`, null) as XMLHttpRequest;
                const Xml = response.responseXML;
                const items = Xml.getElementsByTagName('Z_InsertsUpdates');
                console.log(response);
                if(await RedirecPagMantenimiento(response.status,context)){
                    for (var i = 0; i < items.length; i++) {
                        const current = items[i];
                        const Cabecera = current.getElementsByTagName('Cabecera')[0];
                        const PosicionList = current.getElementsByTagName('PosicionList')[0];
                        const PosicionItems = PosicionList.getElementsByTagName('Z_CustomerSystem_DJ_Posicion');

                        if (ddjj_id != Cabecera.getElementsByTagName('Id_declaracion')[0].textContent) {
                            const moneda = Cabecera.getElementsByTagName('Moneda_des')[0].textContent;
                            for (var index = 0; index < PosicionItems.length; index++) {
                                const item = {
                                    Id_declaracion: Cabecera.getElementsByTagName('Id_declaracion')[0].textContent,
                                    Cod_cliente: Cabecera.getElementsByTagName('Cod_cliente')[0].textContent,
                                    Fecha: Cabecera.getElementsByTagName('Fecha')[0].textContent,
                                    Nro_contrato: Cabecera.getElementsByTagName('Nro_contrato')[0].textContent,
                                    Moneda: Cabecera.getElementsByTagName('Moneda')[0].textContent,
                                    Moneda_des: moneda.charAt(0).toUpperCase() + moneda.slice(1).toLowerCase(),
                                    Tipo_cambio: Cabecera.getElementsByTagName('Tipo_cambio')[0].textContent,
                                    Estado: Cabecera.getElementsByTagName('Estado')[0].textContent,
                                    Fecha_reg: Cabecera.getElementsByTagName('Fecha_reg')[0].textContent,
                                    Id_usuario: Cabecera.getElementsByTagName('Id_usuario')[0].textContent,
                                    Id_historial: Cabecera.getElementsByTagName('Id_historial')[0].textContent,
                                    Id_posicion: PosicionItems[index].getElementsByTagName('Id_posicion')[0].textContent,
                                    Importe: PosicionItems[index].getElementsByTagName('Importe')[0].textContent,
                                    Local: PosicionItems[index].getElementsByTagName('Local')[0] ? PosicionItems[index].getElementsByTagName('Local')[0].textContent : "",
                                    Rubro: PosicionItems[index].getElementsByTagName('Rubro')[0].textContent,
                                    Id_rubro: PosicionItems[index].getElementsByTagName('Id_rubro')[0].textContent,
                                    Cantidad: PosicionItems[index].getElementsByTagName('Cantidad')[0].textContent,
                                    show: true
                                }
                                Home.tablas.visualizar.push(item)
                            }
                        }                        
                        ddjj_id = Cabecera.getElementsByTagName('Id_declaracion')[0].textContent;
                    }
                    Home.pagination.count = Home.tablas.visualizar.length;
                    Home.pagination.pages = Math.ceil(Home.tablas.visualizar.length / Home.pagination.rowPerPage);
                    context.root.$store.commit('ChangeLoader', false);
                }                
            } else {
                Alerts.Throw('Por favor verifique los campos:<br><br>El campo "Desde" no puede menor a 6 meses y el campo "Hasta" no puede ser mayor a Hoy.', AlertType.Danger, false, 5000)
            }
        }

        const Print = () => {
            context.root.$store.commit('ChangeLoader', true)
            const PDF = GetPDFTemplate();

            PDF.content[1].text = 'Presentación de DDJJ de ventas';
            PDF.content[2].text = 'Acá puede ver todas las ventas declaradas que serán facturadas.';
            PDF.content[3].columns[1].text = Home.desde;
            PDF.content[3].columns[3].text = Home.hasta;

            if (tablaVisualizar.value.length > 0) {
                for (var i = 0; i < tablaVisualizar.value.length; i++) {
                    const item = tablaVisualizar.value[i];
                    const price = SetPrice(item.Importe);
                    PDF.content[4].table.body.push([
                        { text: item.Fecha.split("T")[0], style: 'tableContent' },
                        { text: item.Nro_contrato, style: 'tableContent' },
                        { text: item.Local, style: 'tableContent' },
                        { text: item.Rubro, style: 'tableContent' },
                        { text: item.Moneda, style: 'tableContent' },
                        { text: item.Tipo_cambio, style: 'tableContent' },
                        { text: price, style: 'tableContent' },
                    ]);
                }
            } else {
                PDF.content[4].table.body.push([
                    {
                        text: 'No se encontraron resultados.',
                        colSpan: 7,
                        bold: true
                    }, {}, {}, {}, {}, {}, {}
                ])
            }
            context.root.$store.commit('ChangeLoader', false)
            pdfMake.createPdf(PDF).print();
        }

        onBeforeMount(() => {
            VisualizarDDJJ();
        })

        return {
            ...toRefs(Home),
            ...toRefs(context.root.$store.state),
            tablaVisualizar,
            Search,
            VisualizarDDJJ,
            Print,
            SetPrice,
            GetPDFTemplate,
            FormatDate
        }
    }
})
